var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-card',{staticStyle:{"height":"500px"}},[_c('apexchart',{staticStyle:{"margin-left":"200px"},attrs:{"width":"80%","type":"bar","options":_vm.options,"series":_vm.series}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }